import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Snackbar} from "../../../../../util/snackbar";
import {Imovel} from "../../../../../model/Imovel";
import {PropertyProvider} from "../../../../../providers/company/property/property";
import {HttpErrorResponse} from "@angular/common/http";
import {ErrorUtil} from "../../../../../util/error";

@Component({
  selector: 'app-deletar-imovel',
  templateUrl: './deletar-imovel.component.html',
  styleUrls: ['./deletar-imovel.component.scss']
})
export class DeletarImovelComponent implements OnInit {
  enviando: boolean = false;

  constructor(public dialogRef: MatDialogRef<DeletarImovelComponent>,
              public propertyProvider: PropertyProvider,
              public errorUtil: ErrorUtil,
              public snackbar: Snackbar,
              @Inject(MAT_DIALOG_DATA) public data: Imovel) {
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close("cancelou");
  }

  onYesClick(): void {
    this.enviando = true;
    this.propertyProvider.deleteProperty(this.data.propertyCode).then(() => {
      this.snackbar.openLong('Excluído com sucesso!', 'success');
      this.dialogRef.close("Apagou");
    }).catch((result: HttpErrorResponse) => {
      console.error(result);
      this.enviando = false;
      this.snackbar.openLong('Não foi possível excluir! ' + this.errorUtil.checkErrorStatus(result, result.status, result.error, 'property'), 'erro');
    })
    ;
  }


}
